import MarkdownRender from 'LuxKit/MarkdownRender'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import type { VoucherDisplayConfigVoucher } from 'api/promo'
import { isBetaVoucherFeatureEnabled } from 'lib/voucher/isBetaVoucherFeatureEnabled'

type VoucherAnyType = App.PublicVoucher | App.PublicVoucherCalculated | VoucherDisplayConfigVoucher
type VoucherConditionResult = NonNullable<App.PublicVoucher['conditions']>[number]['rewardGroup']['results'][number]

type Props = {
  voucher: VoucherAnyType
  conditionResults?: Array<VoucherConditionResult>
}

const defaultConditionResults: Array<VoucherConditionResult> = []

export function preserveLineBreaks(description: string): string {
  return description.replace(/(?<!\n)\n(?!\n)/g, '  \n')
}

function VoucherDetailsContent({ voucher, conditionResults = defaultConditionResults }: Props) {
  const showConditionResults = isBetaVoucherFeatureEnabled(voucher)
  return <>
    {voucher.voucherDescription ? (
      <MarkdownRender content={preserveLineBreaks(voucher.voucherDescription)} fontSize="medium" type="compact" />
    ) : null}
    {showConditionResults && conditionResults.length > 0 && (
      <Group direction="vertical" gap={2}>
        {conditionResults.map((result, index) => (
          <BodyText
            key={`${result.code ?? 'result'}-${index}`}
            variant="small"
            colour={result.checkPassed ? 'success' : 'critical'}
          >
            {result.conditionResultText}
          </BodyText>
        ))}
      </Group>
    )}
  </>
}

export default VoucherDetailsContent
